module.exports = __webpack_public_path__ + "images/emoji/rat.cb7519678d4327803aa8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rat.png
// module id = Pot+
// module chunks = 13